import {Container, Loader, Stack, Text, Title} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {quoteToDraft} from '../../../../quotes/quote-adapters'
import {QuoteBuilderPage} from '../../../../quotes/quote-builder-page'
import {useQuote} from '../../../../quotes/use-quotes'

export const Route = createFileRoute('/_app/quotes/$quoteId/')({
    component: QuoteEditRoute,
})

function QuoteEditRoute() {
    const {quoteId} = Route.useParams()
    const {data: quote, isLoading, isError, error} = useQuote(quoteId)

    if (isLoading) {
        return (
            <Container size="lg" py="xl">
                <Stack align="center" gap="md" py="xl">
                    <Loader />
                    <Text c="dimmed">Loading quote…</Text>
                </Stack>
            </Container>
        )
    }

    if (isError || quote == null) {
        return (
            <Container size="lg" py="xl">
                <Stack gap="md">
                    <Title order={1}>Quote</Title>
                    <Text c="red">
                        {error instanceof Error ? error.message : 'Failed to load quote'}
                    </Text>
                </Stack>
            </Container>
        )
    }

    return (
        <Container size="lg" py="xl">
            <QuoteBuilderPage
                key={quoteId}
                mode="edit"
                quoteId={quoteId}
                projectId={quote.projectId}
                initialDraft={quoteToDraft(quote)}
            />
        </Container>
    )
}
